<template>
<div style="padding: 20px">
  <div style="height: 60px;line-height: 60px;font-size: 26px;text-align: center">个人信息</div>
  <div><el-input v-model="user" style="width: 100%"></el-input></div>
  <div><el-button style="width: 100%;margin-top: 20px" @click="editUser">修改</el-button></div>
  <div style="margin-top: 20px;color: red">用于不同浏览器间的数据迁移，修改完成后刷新页面即可，谨慎操作</div>
</div>
</template>

<script>

import VueCookies from "vue-cookies"
export default {
  name: "UserProfile",
  data(){
    return {
      user:''
    }
  },
  created() {
    this.user=localStorage.id
  },
  methods:{
    editUser(){
      localStorage.id=this.user
      VueCookies.set('score_record_user',this.user)
      this.$message({
        message:'修改成功，请刷新页面',
        type: 'success'
      });
    }
  }
}
</script>

<style scoped>

</style>